import { ConnectionCreatedEvent } from './graphViz/ConnectionCreatedEvent';
import {GraphConfig} from './graphViz/graphConfig';
import {GraphViz} from './graphViz/graphViz';
import {GraphexpService, GraphsonFormat} from './graphexp.service';
import { LinkEditComponent } from './link-edit/link-edit.component';
import {NodeEditComponent} from './node-edit/node-edit.component';
import {D3Node} from './nodes/d3Node';
import { GremlinLink } from './nodes/gremlinLink';
import {GremlinNode} from './nodes/gremlinNode';
import {Component, OnInit, Input, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material';
import {GremlinService, GremlinClientOptions, GremlinQuery} from '@savantly/gremlin-js';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import * as d3 from 'd3';


@Component({
  selector: 'sv-graphexp',
  template: `<div fxLayout fxFlexFill class="content sv-graphexp">
	<mat-sidenav-container fxFLex>
		<mat-sidenav #graphexpSideMenu position="end" fxLayout="column" fxLayoutGap="1.5em">
			<button mat-mini-fab color="accent" (click)="graphexpSideMenu.toggle()">
		      <mat-icon>arrow_right</mat-icon>
		    </button>
		    <div fxLayout fxLayoutGap="1em">
		    	<button mat-raised-button (click)="getGraphInfo()">
		    		Refresh<mat-icon>refresh</mat-icon>
		    	</button>
		    	<button mat-raised-button (click)="openNodeEditDialog()">
					Create<mat-icon>add</mat-icon>
				</button>
		    	<span fxFlex></span>
				<button mat-raised-button (click)="clearGraph()">
					Clear<mat-icon>clear</mat-icon>
				</button>
		    </div>
		    <mat-checkbox [(ngModel)]="showGraphInfo">Show Graph Info</mat-checkbox>
		    <mat-checkbox>Show Selection Properties</mat-checkbox>
		    <mat-checkbox (click)="showNames()">Show Labels</mat-checkbox>
		    <mat-checkbox>Freeze Graph</mat-checkbox>
			<section>
				<div fxLayout>
					<label>Visible Layers</label>
		    		<mat-slider min="1" max="5" [(ngModel)]="numberOfLayers" thumbLabel tickInterval="1"></mat-slider>
				</div>
		    </section>		    
		</mat-sidenav>
		<div fxLayout="column" fxFlexFill>
			<mat-toolbar fxLayoutGap="1em">
			    <label>Search</label>
				<mat-form-field>
					<mat-select [(ngModel)]="searchField">
						<mat-optgroup label="Node">
							<mat-option value="id">id</mat-option>
							<mat-option *ngFor="let item of nodeProperties | async" [value]="item">{{item}}</mat-option>
						</mat-optgroup>
						<mat-optgroup label="Edge">
							<mat-option value="id">id</mat-option>
							<mat-option *ngFor="let item of edgeProperties | async" [value]="item">{{item}}</mat-option>
						</mat-optgroup>
					</mat-select>
				</mat-form-field>
				<mat-input-container>
					<input matInput name="searchValue" [(ngModel)]="searchValue" placeholder="Id/Keyword">
				</mat-input-container>
				<button (click)="search()" mat-mini-fab>
					<mat-icon>search</mat-icon>
				</button>
				<button mat-mini-fab (click)="openNodeEditDialog()">
					<mat-icon>add</mat-icon>
				</button>
			    <span fxFlex></span>
				<button mat-mini-fab (click)="graphexpSideMenu.toggle()">
			      <mat-icon>menu</mat-icon>
			    </button>
			</mat-toolbar>
			
			<div class="sv-graphexp-content">
				<div class="sv-graphexp-left-bar">
					<div *ngIf="showGraphInfo"><br/>
						<strong>Node Names</strong>
						<div *ngFor="let item of nodeNames | async">
							{{item.key}}: {{item.value}}
						</div>
					</div>
				</div>
				<div class="sv-graphexp-right-bar">
					<strong>Selected Node</strong>
						<div *ngIf="selectedNode">
							<div>Label: {{selectedNode.label}}</div>
							<div>Type: {{selectedNode.type}}</div>
							<div *ngFor="let prop of getFlattenedNodeProperties(selectedNode)">
								<div>{{prop.name}}: {{prop.value}}</div>
							</div>
						</div>
				</div>
				
				<div class="sv-graphexp" id="sv_graphexp">
					<svg></svg>
				</div>
			</div>
		</div>
	</mat-sidenav-container>
</div>

`,
  styles: [`.hidden{
	display:none;
}

.sv-graphexp mat-sidenav-container{
	width:100%;
}
.sv-graphexp mat-sidenav{
	padding:1em;
	width:25em;
}
.sv-graphexp mat-divider{
	padding:5px 0;
}

div.sv-graphexp{
	height:100%;
} 

.sv-graphexp-content{
	padding:1em;
	position:relative;
	top:0;
	height:100%;
}

.sv-graphexp-left-bar{
	position:absolute;
	top:0;
	width:10em;
}

.sv-graphexp-right-bar{
	position:absolute;
	top:0;
	right:0;
	width:10em;
}

path.drag-line{
    fill:none;
    stroke:#333;
    stroke-width:4px;
    stroke-dasharray:5 5;
    cursor:default;
}

.edge{
	stroke:#999;
	stroke-opacity:0.8;
}

.old_edge0{
	stroke:#999;
	stroke-opacity:0.6;
}

.node circle{
	stroke:#000;
	stroke-width:1.5px;
}

.node text{
	font:10px sans-serif;
}

.node:hover circle{
	stroke-opacity:0.6;
}

.pinned circle{
	stroke:#000;
	stroke-width:1.5px;
}

.pinned text{
	font:10px sans-serif;
}

.pinned:hover circle{
	stroke-opacity:0.6;
}

.old_node0 circle{
	stroke-opacity:0.9;
}

.old_node0 text{
	font:10px sans-serif;
	opacity:0.9;
	color:#000;
	color:rgba(0, 0, 0, 0.5);
}

.cell{
	fill:none;
	pointer-events:all;
}`],
  encapsulation: ViewEncapsulation.None
})
export class GraphexpComponent implements OnInit {

  @Input()
  graphexpService: GraphexpService;
  @Input()
  graphConfig?: GraphConfig;

  public searchValue = '';
  public searchField = 'id';
  public graphInfoData: {};
  public numberOfLayers = 3;
  public showGraphInfo = true;
  public newNode: any = {};
  private graphViz: GraphViz;

  get selectedNode() {
    if (this.graphViz && this.graphViz.selectedNode && this.graphViz.selectedNode.value) {
      return this.graphViz.selectedNode.value;
    } else {
      return null;
    }
  }

  get nodeNames() {
    return this.graphexpService.nodeNames;
  };
  get nodeProperties() {
    return this.graphexpService.nodeProperties;
  };
  get edgeProperties() {
    return this.graphexpService.edgeProperties;
  };
  get enableEdit() {
    return (this.graphConfig && this.graphConfig.enableEdit);
  }
  get nodeLabels() {
    return this.graphConfig.nodeLabels;
  }
  get linkLabels() {
    return this.graphConfig.linkLabels;
  }

  ngOnInit(): void {
    if (!this.graphConfig) {
      this.graphConfig = new GraphConfig();
    }
    this.graphViz = new GraphViz(this.graphexpService, this.graphConfig);
    setTimeout(() => {
      this.graphViz.init('#sv_graphexp');
      this.graphexpService.queryGraphInfo();

      this.graphViz.connectionCreated.subscribe((val: ConnectionCreatedEvent) => {
        console.log(`GraphexpComponent#ngAfterViewInit: connection created ${val}`);
        const gremlinLink = new GremlinLink();
        gremlinLink.source = val.source.id;
        gremlinLink.target = val.target.id;
        this.openLinkEditDialog(gremlinLink);
      });

      this.graphViz.createNodeEvent.subscribe((d3Node: D3Node) => {
        if (d3Node === null) {
          return;
        }
        const gremlinNode = new GremlinNode();
        this.openNodeEditDialog(gremlinNode);
      });
    });

  }

  openLinkEditDialog(item: GremlinLink) {
    const dialogRef = this.dialog.open(LinkEditComponent, {
      width: '30em',
      data: {labels: this.linkLabels, item: item}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.createLink(result);
      }
    });
  }

  openNodeEditDialog(item?: GremlinNode) {
    item = item || new GremlinNode();
    const dialogRef = this.dialog.open(NodeEditComponent, {
      width: '30em',
      data: {labels: this.nodeLabels, item: item}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.createNode(result);
      }
    });
  }

  createLink(data: GremlinLink) {
    this.graphexpService.createLink(data).then(tinkerNode => {
      console.log(data);
    }, err => {console.error(err)});
  }

  createNode(data: GremlinNode) {
    this.graphexpService.createNode(data.label, data.properties).then(tinkerNode => {
      console.log(data);
    }, err => {console.error(err)});
  }

  search() {
    console.log(`searching field: ${this.searchField}, value: ${this.searchValue}`);
    this.graphexpService.queryNodes(this.searchField, this.searchValue).then(data => {
      this.graphViz.refreshData(data, 1, null);
    }).catch((err) => {
      console.error(err);
    });
  }

  getFlattenedNodeProperties(node: D3Node) {
    const props = [];
    for (const prop of Object.keys(node.properties)) {
      const valArray = node.properties[prop];
      const val = valArray[0]['value'];
      props.push({
        name: prop,
        value: val
      });
    }
    return props;
  }

  showNames() {
  }

  setNumberOfLayers() {
    this.graphConfig.numberOfLayers = this.numberOfLayers;
  }

  clearGraph() {
    this.graphViz.clear();
  }

  toggleGraphInfo() {
    this.showGraphInfo = !this.showGraphInfo;
  }

  getGraphInfo() {
    this.graphexpService.queryGraphInfo();
  }

  constructor(public dialog: MatDialog) {}

}
